import { Config } from "/js/config/Config";

export class ViewModeHelper {
    constructor() {
        this.config = new Config();
        /**
         * 뷰모드 설정
         * 0: 기본뷰모드
         * 1: 데스크탑뷰모드(force desktop)
         */
        this.viewMode = 0;
        
        /**
         * 실제 기기 화면 너비 (viewport 변경 전 원본 크기)
         */
        this.actualDeviceWidth = 0;

        this.initViewMode();
    }

    async initViewMode() {
        await this.config.ensureLoaded();
        // 기기가 로컬스토리지를 이용가능한지 확인해서 없으면 기본값 뷰모드(0) 설정
        if (!this.supports_local_storage()) {
            this.viewMode = 0;
        }

        // 터치 지원 여부 감지
        const isTouchDevice = ('ontouchstart' in window) || (navigator.maxTouchPoints > 0);

        // 최초 접속 시 실제 기기 크기 및 터치 지원 여부 저장 (viewport 변경 전)
        if (this.supports_local_storage() && !localStorage.getItem('actualDeviceWidth')) {
            localStorage.setItem('actualDeviceWidth', window.screen.width.toString());
            localStorage.setItem('isTouchDevice', isTouchDevice.toString());
        }

        // 실제 기기 크기 불러오기
        if (this.supports_local_storage() && localStorage.getItem('actualDeviceWidth')) {
            this.actualDeviceWidth = parseInt(localStorage.getItem('actualDeviceWidth'));
        }

        // 터치 지원 여부 불러오기
        const savedIsTouchDevice = this.supports_local_storage() && localStorage.getItem('isTouchDevice') === 'true';

        // 로컬스토리지에 뷰모드가 저장되어 있으면 불러오기
        if (this.supports_local_storage() && localStorage.getItem('viewMode')) {
            this.viewMode = parseInt(localStorage.getItem('viewMode'));
        }

        // viewMode가 1이면 viewport.setAttribute('content', 'width=1442, user-scalable=yes');
        if (this.viewMode === 1) {
            let viewport = document.querySelector("meta[name=viewport]");
            // url에 caView.php가 포함되어있는지 확인
            // 예를들면 https://www.dooinauction.com/ca/caView.php?tid=1544571&chkNo=1&TotNo=20
            const isCaViewPage = window.location.href.includes('caView.php');
            if (viewport && isCaViewPage) {
                viewport.setAttribute('content', 'width=1200, user-scalable=yes');
            } else if (viewport) {
                viewport.setAttribute('content', 'width=1442, user-scalable=yes');
            }
        }

        console.log(`ViewModeHelper initialized: viewMode=${this.viewMode}, actualDeviceWidth=${this.actualDeviceWidth}, isTouchDevice=${savedIsTouchDevice}`);

        // localhost 체크
        const isLocalhost = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';

        // 버튼 표시 조건
        let shouldShowButton = false;
        
        if (isLocalhost) {
            // localhost: 개발 환경이므로 무조건 버튼 표시
            shouldShowButton = true;
        } else {
            // 실서버: 터치 가능 기기 && 화면 크기 1441px 미만
            shouldShowButton = savedIsTouchDevice && this.actualDeviceWidth < 1441;
        }

        if (shouldShowButton) {
            $('.footer_pc_mode').show();
            if (this.viewMode === 1) {
                $('#FORCE_PC_MODE_BTN').hide();
                $('#FORCE_PC_MODE_CANCEL_BTN').show();
            } else {
                $('#FORCE_PC_MODE_BTN').show();
                $('#FORCE_PC_MODE_CANCEL_BTN').hide();
            }
        } else {
            // 데스크탑 기기 또는 터치 미지원 기기에서는 버튼 자체를 숨김
            $('.footer_pc_mode').hide();
        }
    }

    supports_local_storage() {
        return (typeof window.localStorage != 'undefined');
    }

    saveViewMode(viewMode) {
        this.viewMode = viewMode;
        if (this.supports_local_storage()) {
            localStorage.setItem('viewMode', viewMode.toString());
        }
    }

    getViewMode() {
        return this.viewMode;
    }

    isForceDesktop() {
        return (this.viewMode === 1);
    }

    // 강제 PC버전 보기 이벤트리스너
    setForceDesktopButtonListener() {
        $(`#FORCE_PC_MODE_BTN`).on('click', () => {
            this.saveViewMode(1);
            location.reload();
        });
        $(`#FORCE_PC_MODE_CANCEL_BTN`).on('click', () => {
            this.saveViewMode(0);
            location.reload();
        });
    }
}